// Shared humanisation for backend event-status enums.
// Mirror of mobile /app/mobile/src/lib/event-labels.ts

const STATUS_MAP = {
  DRAFT: 'Draft',
  SCHEDULED: 'Scheduled',
  COLLECTING: 'Collecting',
  PAUSED: 'Paused',
  CURATING: 'Curating',
  LOOKBOOK_LIVE: 'Lookbook Live',
  ARCHIVED: 'Archived',
};

export function eventStatusLabel(status) {
  if (!status) return '\u2014';
  return STATUS_MAP[status] || status;
}

export function statusPillClasses(status) {
  switch (status) {
    case 'COLLECTING': return 'bg-[#E4F4EC] text-[#1F8A55]';
    case 'LOOKBOOK_LIVE': return 'bg-[#EFF5FF] text-[#146BFF]';
    case 'PAUSED': return 'bg-[#FFF6E5] text-[#B86500]';
    case 'CURATING': return 'bg-[#FFF6E5] text-[#B86500]';
    case 'DRAFT': return 'bg-[#F3F5F8] text-[#5B6472]';
    case 'ARCHIVED': return 'bg-[#F3F5F8] text-[#5B6472]';
    default: return 'bg-[#EFF5FF] text-[#146BFF]';
  }
}
